import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useSearchParams, Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function AccessDeniedPage() {
  const { user, logout } = useAuth();
  const [searchParams] = useSearchParams();
  const iamGroup =
    searchParams.get('group') ??
    'GRP-APS-AJO-DESIGN-AGENT-DEV-USERS';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom fontWeight={700}>
            Access required
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            You are signed in{user?.email ? ` as ${user.email}` : ''}, but you do not have access to
            AJO Design Agent.
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Ask your admin to add you to the IAM group{' '}
            <Typography component="span" variant="body2" fontFamily="monospace">
              {iamGroup}
            </Typography>
            . Group changes can take 90–120 minutes to propagate.
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary="Subscribe at iam.corp.adobe.com/groups/subscribe" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Return here and sign in again after approval" />
            </ListItem>
          </List>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button variant="contained" href="https://iam.corp.adobe.com/groups/subscribe" target="_blank">
              Request access
            </Button>
            <Button component={RouterLink} to="/" variant="outlined">
              Home
            </Button>
            <Button onClick={() => logout()} color="inherit">
              Sign out
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
